.bar { display: flex; align-items: center; gap: var(--space-3); height: var(--topbar-height); padding: 0 var(--space-3) 0 var(--space-2); background: var(--color-surface-sunken); }
.search {
  display: flex; align-items: center; gap: var(--space-3); flex: 1; min-width: 0; max-width: 720px; height: 44px; padding: 0 var(--space-3) 0 var(--space-4);
  border: 1px solid transparent; border-radius: var(--radius-full); background: var(--color-surface); color: var(--color-text-muted); text-align: left;
  box-shadow: var(--shadow-1);
  transition: border-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;
}
.search:hover { border-color: var(--color-border-strong); }
.search svg { width: 18px; height: 18px; flex: none; }
.placeholder { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.keys { display: flex; gap: 2px; }
.right { display: flex; align-items: center; gap: var(--space-1); margin-left: auto; }
.preview { padding: 2px var(--space-2); border: 1px solid var(--color-warning); border-radius: var(--radius-full); color: var(--color-warning); background: var(--color-warning-surface); font-size: var(--text-xs); font-weight: var(--weight-medium); white-space: nowrap; }
.account { display: grid; place-items: center; width: 40px; height: 40px; margin-left: var(--space-1); border: 0; border-radius: var(--radius-full); background: transparent; padding: 0; }
.account:hover { background: var(--color-surface-hover); }
.account:focus-visible { border-radius: var(--radius-full); }
.who { display: flex; align-items: center; gap: var(--space-3); padding: var(--space-3) var(--space-2); }
.whoName { font-weight: var(--weight-semibold); }
.whoEmail { color: var(--color-text-muted); font-size: var(--text-sm); }
@media (max-width: 899px) {
  .keys, .hideNarrow { display: none; }
  .search { height: 40px; }
  .preview { display: none; }
}
.chatButton { position: relative; display: inline-flex; }
.chatBadge {
  position: absolute; top: 2px; right: 0; min-width: 18px; height: 18px; padding: 0 5px; border-radius: var(--radius-full); pointer-events: none;
  background: var(--color-primary); color: var(--color-text-on-primary); box-shadow: 0 0 0 2px var(--color-surface-sunken);
  font-size: var(--text-2xs); font-weight: var(--weight-semibold); line-height: 18px; text-align: center; font-variant-numeric: tabular-nums;
}
